
import MyCourse from './MyCourse'

export default MyCourse